import axios from "axios";

const apiUrl = process.env.REACT_APP_BACKEND_API_HOST;

const axiosPublic = axios.create({
  baseURL: `${apiUrl}`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json;charset=utf-8",
  },
});

// ─── @deprecated ────────────────────────────────────────────────────────
// Endpoints legacy usados por StatisticsModulePage (CI/CLB).
// Reemplazados por los endpoints G1-G10 en Estadisticas.jsx.
// TODO: eliminar junto con useStatisticsData.js, StatisticsModulePage.jsx,
//       EstadisticasCI.jsx, EstadisticasCLB.jsx y statsModuleConfig.js.
// ────────────────────────────────────────────────────────────────────────
// const getSexesLocatedByMunicipality = async () =>
//   await axiosPublic.get(`version_publica/grafica_municipios_sexos_localizados/`);
// const getLocalizedAgeRange = async () =>
//   await axiosPublic.get(`version_publica/grafica_rangoedad_localizados/`);
// const getLocatedByYearSexAndCondition = async () =>
//   await axiosPublic.get(`version_publica/grafica_anios_condicion_localizados/`);
// const getLocatedByCrimeVictim = async () =>
//   await axiosPublic.get(`version_publica/grafica_aniosreporte_victimadelito_localizados/`);
// const getAgeRangeClassification = async () =>
//   await axiosPublic.get(`version_publica/grafica_rangoedad_usoviolencia_desaparecidos/`);
// const getSexesMissingByMunicipality = async () =>
//   await axiosPublic.get(`version_publica/grafica_municipios_sexos_desaparecidos/`);
// const getYearRangeMissingClassification = async () =>
//   await axiosPublic.get(`version_publica/grafica_aniosreporte_usoviolencia_desaparecidos/`);
// const getStatisticsGraphicsRequestsByModule = (moduleType = "ci") => { ... };


/* nuevos endpoint para las graficas */

// G1: Personas desaparecidas por año de desaparición y sexo
export const getMissingByYearAndSex = async () =>
  await axiosPublic.get(`version_publica/grafica_personas_desaparecidas_por_año_sexo/`);

// G2: Personas desaparecidas periodo comparable (1 enero 2019 al corte)
export const getMissingComparable = async () =>
  await axiosPublic.get(`version_publica/personas_desaparecidas_1_enero_2019_al_corte/`);

// G3: Desapariciones con/sin violencia por año - Fiscalía
export const getMissingViolenceFiscalia = async () =>
  await axiosPublic.get(`version_publica/desapariciones_con_violencia_sin_violencia_por_año_fiscalia/`);

// G4: Mujeres desaparecidas por año y rango de edad
export const getWomenMissingByAgeRange = async () =>
  await axiosPublic.get(`version_publica/mujeres_desaparecidas_año_rango_edad/`);

// G5: Hombres desaparecidos por año y rango de edad
export const getMenMissingByAgeRange = async () =>
  await axiosPublic.get(`version_publica/hombres_desaparecidos_año_rango_edad/`);

// G6: Personas localizadas por condición de localización y víctimas de delito
export const getLocatedByConditionAndCrime = async () =>
  await axiosPublic.get(`version_publica/personas_localizadas_condición_localización_victimas_delito/`);

// G7: Porcentaje de localización por año
export const getPercentageByYear = async () =>
  await axiosPublic.get(`version_publica/porcentaje_localizacion_año/`);

// G8: Porcentaje de localización periodo comparable (2019 al corte)
export const getPercentageComparable = async () =>
  await axiosPublic.get(`version_publica/porcentaje_localizacion_2019_corte/`);

// G9: Mujeres localizadas por condición de localización y víctimas de delito
export const getWomenLocatedByCrime = async () =>
  await axiosPublic.get(`version_publica/mujeres_localizadas_condicion_localizacion_victimas_delito/`);

// G10: Hombres localizados por condición de localización y víctimas de delito
export const getMenLocatedByCrime = async () =>
  await axiosPublic.get(`version_publica/hombres_localizadas_condicion_localizacion_victimas_delito/`);

// G11: Con Carpeta y Sin carpeta
export const getConSinCarpeta = async () =>
  await axiosPublic.get(`version_publica/desapariciones_con_sin_carpeta/`);
